import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserSettingsFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.104 3.078a4.664 4.664 0 0 1 4.665 4.665 4.664 4.664 0 0 1-4.665 4.665 4.664 4.664 0 1 1 0-9.33M10.089 14.436c-1.42 0-2.738.203-3.752.507-.61.203-1.217.507-1.623.912a2.45 2.45 0 0 0-.71 1.724c0 .71.203 1.218.71 1.724.406.406 1.014.71 1.623.912 1.014.305 2.332.508 3.752.508.609 0 1.014-.405 1.014-1.014v-4.26c0-.607-.405-1.014-1.014-1.014M19.52 17.883l-.101-.101v-.913l.1-.102c.508-.305.609-.912.305-1.42-.304-.506-.912-.608-1.42-.303h-.101c-.203-.203-.406-.306-.71-.407v-.101c0-.608-.405-1.014-1.014-1.014-.608 0-1.014.406-1.014 1.014-.304.101-.608.203-.811.406-.507-.305-1.116-.101-1.42.303-.304.508-.101 1.117.304 1.42h.102c-.102.305-.102.71 0 1.015h-.102c-.507.303-.608.913-.304 1.42s.913.607 1.42.303c.304.204.507.407.81.508 0 .608.407 1.013 1.015 1.013.609 0 1.014-.404 1.014-1.014v-.1c.203-.102.507-.203.71-.406h.102c.507.303 1.115.203 1.419-.305.304-.303.203-1.014-.304-1.216m-2.941.303a.91.91 0 0 1-.913-.912c0-.508.406-.913.913-.913s.913.406.913.913a.91.91 0 0 1-.913.912"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserSettingsFilled);
export default ForwardRef;
